import { createRequest } from 'helpers/request'

export const request = createRequest({
  baseURL: 'https://commerce.errandlr.com',
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${process.env.ERRANDLR_API_KEY}`,
  },
})
